import React from "react";
import { Box, Code, Text, Stack } from "@mantine/core";
import { useAppSelector } from "../hooks"; // Ersätt med korrekt import-väg till dina Redux hooks
import { selectSelectedChecklistTemplate } from "./checklistTemplatePageSelectors"; // Ersätt med korrekt import-väg till selectorn
import MCTempalteExportChecklist from "./MCTempalteExportChecklist";
import PublishChecklist from "./McPublishChecklist";

const SingleMcTemplate: React.FC = () => {
  const selectedTemplate = useAppSelector(selectSelectedChecklistTemplate);

  return (
    <Box h="100%">
      <Text weight={500} mb="xs">
        Valgt mal:
      </Text>
      <Stack>
        {selectedTemplate ? (
          <Stack gap="sm">
            <Code block style={{ backgroundColor: "#f5f5f5", padding: "16px", borderRadius: "4px" }}>
              {JSON.stringify(selectedTemplate, null, 2)}
            </Code>
            <PublishChecklist checklistNrId={selectedTemplate.id} />
            <MCTempalteExportChecklist />
          </Stack>
        ) : (
          <Text c="dimmed" italic>
            Ingen mal valgt
          </Text>
        )}
      </Stack>
    </Box>
  );
};

export default SingleMcTemplate;
